import { format, parseISO } from 'date-fns';
import { useFormikContext } from 'formik';

import { ErrorField } from '@/components/error-field';
import { RequiredLabel } from '@/components/required-label';
import { Combobox } from '@/components/ui/combobox';
import { DatePickerTime } from '@/components/ui/date-time-picker';
import { Label } from '@/components/ui/label';

import type { BatchCallUpdateFormValues } from '@/schemas/batch-call.schema';

import { TIMEZONE_OPTIONS } from '@/constants';

import { useFormikError } from '@/lib/error';

export const WhenToSendField = () => {
  const { values, setFieldValue, errors, touched } = useFormikContext<BatchCallUpdateFormValues>();
  const hasError = useFormikError();

  const scheduledDateValue = values.scheduledDate ? parseISO(values.scheduledDate) : undefined;

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium text-zinc-950">When to Send the Calls</Label>
      <div className="space-y-4">
        <DatePickerTime
          dateId="scheduledDate"
          timeId="scheduledTime"
          date={scheduledDateValue}
          time={values.scheduledTime}
          onDateChange={date =>
            setFieldValue('scheduledDate', date ? format(date, 'yyyy-MM-dd') : '')
          }
          onTimeChange={time => setFieldValue('scheduledTime', time)}
          dateAriaInvalid={hasError('scheduledDate')}
          timeAriaInvalid={hasError('scheduledTime')}
        />

        <div className="space-y-2">
          <RequiredLabel htmlFor="scheduledTimezone" className="text-sm">
            Timezone
          </RequiredLabel>
          <Combobox
            id="scheduledTimezone"
            options={TIMEZONE_OPTIONS}
            value={values.scheduledTimezone}
            onValueChange={tz => setFieldValue('scheduledTimezone', tz)}
            placeholder="Select timezone..."
            searchPlaceholder="Search timezone..."
            emptyMessage="No timezone found."
            className={
              touched.scheduledTimezone && errors.scheduledTimezone
                ? 'border-destructive aria-invalid:ring-0'
                : ''
            }
          />
          <ErrorField name="scheduledTimezone" />
        </div>
      </div>
    </div>
  );
};
